/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { exists, isArrayNotEmpty } from "cms/utils/empty-exists";
import { LinkButtonItem } from "./link-button-item";

const LinkButtonComponent = (props) => {

    const component = props?.component;
    const isList = exists(component?.button_list);
    if (isList) {
        const buttonList = component?.button_list;
        return (
            <div className={"link-button-component"}>
                {isArrayNotEmpty(buttonList) &&
                    buttonList.map((item, index) => (
                        <LinkButtonItem
                            key={index}
                            item={item}
                        />
                    ))
                }
            </div>
        );
    } else {
        const guid = component?.guid;
        return (
            <LinkButtonItem
                key={guid}
                item={component}
            />
        );
    }
};

LinkButtonComponent.displayName = "LinkButtonComponent";
export { LinkButtonComponent };
